<template>
  <div v-if="accepting">
    <h1 class="font-bold text-3xl">
      <base-loading class="text-3xl mr-4" /> Confirming account
    </h1>
  </div>
  <div v-else>
    <h1 v-if="error" class="text-red-600 font-bold text-4xl leading-tight mb-8">
      Token incorrect or invitation already confirmed!
    </h1>
    <div v-else-if="userHasUsablePassword">
      <h1 class="text-green-400 font-bold text-3xl leading-tight mb-8">
        Your invitation is confirmed!
      </h1>
      <router-link
        to='{"name": "dashboard-links"}'
        class="inline-block text-sm text-black border-b-2 border-transparent hover:border-blue-400"
      >
        Go to the dashboard
      </router-link>
    </div>
    <div v-else>
      <h1 class="text-green-400 font-bold text-3xl leading-tight mb-4">
        Welcome to Link Manager!
      </h1>
      <p class="text-lg mb-8">Please set your password:</p>
      <FormulateForm
        v-if="!userHasUsablePassword"
        name="setPassword"
        v-model="formValues"
        @submit="setPassword"
      >
        <FormulateInput
          name="password1"
          type="password"
          label="Password"
          placeholder="Your password"
          validation="bail|required|min:8,length"
          validation-name="Password"
        />
        <FormulateInput
          name="password2"
          type="password"
          label="Confirm your password"
          placeholder="Confirm password"
          validation="bail|required|confirm:password1"
          validation-name="Confirmation"
        />
        <base-button type="submit" :loading="sending">
          Set Password
        </base-button>
      </FormulateForm>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      accepting: false,
      sending: false,
      sent: false,
      password: '',
      repeat: '',
      formValues: {},
      userHasUsablePassword: false,
      error: false,
    };
  },
  created() {
    this.acceptInvitation();
  },
  methods: {
    async acceptInvitation() {
      try {
        this.accepting = true;
        const { data } = await this.$api.get(
          `accept_invitation/${this.$route.params.token}/`
        );
        this.userHasUsablePassword = data['user_has_usable_password'];
        await this.$store.dispatch('auth/login', data['auth_token']);
      } catch (error) {
        this.error = true;
      } finally {
        this.accepting = false;
      }
    },
    async setPassword(data) {
      try {
        this.sending = true;
        await this.$api.post('set_initial_password/', data);
        await this.$router.push(
          this.$route.query.redirect || { name: 'dashboard-links' }
        );
      } catch (error) {
        this.$formulate.handle(error, 'setPassword');
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
